import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

export default function QuiSommesNous() {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Bouton retour */}
        <Link
          to="/"
          className="inline-flex items-center text-honey-600 hover:text-honey-700 mb-8"
        >
          <ArrowLeftIcon className="h-5 w-5 mr-2" />
          Retour à l'accueil
        </Link>

        {/* Titre */}
        <h1 className="text-3xl font-bold text-slate-900 mb-8">
          Qui sommes-nous ?
        </h1>

        {/* Contenu principal */}
        <div className="bg-white rounded-xl shadow-sm p-8 space-y-8 ">
          {/* Introduction */}
          <section>
            <p className="text-lg text-slate-700 leading-relaxed text-justify">
              Ensemble, les groupements d'apiculteurs réunionnais
            </p>
            
            {/* Liste des groupements */}
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="border border-slate-200 rounded-lg p-4">
                <h3 className="font-semibold text-slate-900">SAR</h3>
                <p className="text-sm text-slate-700">Syndicat Apicole de La Réunion</p>
              </div>
              <div className="border border-slate-200 rounded-lg p-4">
                <h3 className="font-semibold text-slate-900">AMAIR</h3>
                <p className="text-sm text-slate-700">Association de la Maison de l'Apiculture de l'Ile de la Réunion</p>
              </div>
              <div className="border border-slate-200 rounded-lg p-4">
                <h3 className="font-semibold text-slate-900">ADAR</h3>
                <p className="text-sm text-slate-700">Association pour le Développement de l'Apiculture à L'île de la Réunion</p>
              </div>
              <div className="border border-slate-200 rounded-lg p-4">
                <h3 className="font-semibold text-slate-900">Coopémiel</h3>
                <p className="text-sm text-slate-700">Coopémiel de Bourbon</p>
              </div>
            </div>

            <p className="mt-6 text-slate-600 leading-relaxed text-justify">
              ont pris l'initiative de créer une <strong>plateforme de gestion des relations avec les apiculteurs adhérents</strong>.
            </p>
          </section>

          {/* Objectif */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Notre objectif</h2>
            <p className="text-slate-600 leading-relaxed text-justify">
              Pour les groupements qui fonctionnent sans salarié, l'objectif est de <strong>redynamiser les équipes de bénévoles</strong> en utilisant toutes les possibilités offertes par les outils numériques.
            </p>
          </section>

          {/* Services */}
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">Nos services</h2>
            <p className="text-slate-600 leading-relaxed mb-4 text-justify">
              Outre la gestion des adhésions et des activités statutaires propres de chaque groupement, la plateforme de gestion des relations avec les apiculteurs mutualise des outils de :
            </p>
            <ul className="list-disc list-inside text-slate-600 space-y-2 ml-4 mb-4">
              <li>Communication</li>
              <li>Information</li>
              <li>Participation aux événements apicoles</li>
            </ul>
            <p className="text-slate-600 leading-relaxed text-justify">
              La plateforme est aussi le rendez-vous des apiculteurs souhaitant utiliser les <strong>services de la miellerie collective</strong>, et de tous ceux qui souhaitent recevoir une <strong>formation apicole</strong>, dispensée par les bénévoles issus des quatre groupements.
            </p>
          </section>
        </div>

        {/* Date de mise à jour */}
        <p className="text-sm text-slate-500 mt-6 text-center">
          Dernière mise à jour : Janvier 2026
        </p>
      </div>
    </div>
  );
}
